// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"387":"e1a03800","683":"41a2ff34"}[chunkId] + ".chunk.css";
};